import { action, observable, makeObservable } from "mobx";
import { DadosProcesso } from "../modelo/dominio/DadosProcesso";
import { Peca } from './../modelo/dominio/Peca';
import { Minuta, IEtiqueta } from "../modelo";
import ProcessoStore from "./ProcessoStore";

class ProcessoExpandidoStore {
    dadosProcesso: DadosProcesso;
    idProcessoPainelExpandido: string = '';
    pecas: Peca[];
    minutas: Minuta[] = [];
    minutasArquivadas: Minuta[] = [];
    minutasAssinadas: Minuta[] = [];
    etiquetas: IEtiqueta[] = [];
    abaSelecionada: number = 0;
    carregandoPecas: boolean = false;
    idProcessoCarregandoPecas: number = undefined;

    constructor() {
        makeObservable(this, {
            dadosProcesso: observable,
            idProcessoPainelExpandido: observable,
            pecas: observable,
            minutas: observable,
            minutasArquivadas: observable,
            minutasAssinadas: observable,
            etiquetas: observable,
            abaSelecionada: observable,
            carregandoPecas: observable,
            idProcessoCarregandoPecas: observable,
            setDadosProcesso: action,
            setPecas: action,
            handleMudaAba: action,
            setCarregandoPecas: action,
            limparPecas: action,
            iniciarCarregamentoPecas: action,
            finalizarCarregamentoPecas: action
        });
    }

    setDadosProcesso(dadosProcesso: DadosProcesso): void {
        this.dadosProcesso = dadosProcesso;
    }

    setPecas(pecas: Peca[]): void {
        this.pecas = pecas.map(peca => Peca.novo(peca));
    }

    limparPecas(): void {
        this.pecas = [];
    }

    deveRenderizar(idProcesso: number) {
        if (this.dadosProcesso === undefined || idProcesso !== this.dadosProcesso.idProcesso) {
            return false;
        }
        return true;
    }

    handleMudaAba = (e: React.MouseEvent, novaAbaSelecionada: number) => {
        this.abaSelecionada = novaAbaSelecionada;
    };

    setCarregandoPecas(carregando: boolean): void {
        this.carregandoPecas = carregando;
    }

    iniciarCarregamentoPecas(idProcesso: number): void {
        this.idProcessoCarregandoPecas = idProcesso;
        this.carregandoPecas = true;
        this.limparPecas();
    }

    finalizarCarregamentoPecas(idProcesso: number): void {
        if (this.idProcessoCarregandoPecas === idProcesso) {
            this.carregandoPecas = false;
            this.idProcessoCarregandoPecas = undefined;
        }
    }
}

export default new ProcessoExpandidoStore();
